module.exports = __webpack_public_path__ + "img/assessment.d5b875bb.svg";